
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"740","height":"286","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"opacity":".66","d":"M745-5H-5v296h750V-5z","fill":"#F7D287"}}),_c('path',{attrs:{"opacity":".66","d":"M745-5H-5v296h750V-5z","fill":"#F7D287"}}),_c('path',{attrs:{"opacity":".63","d":"M370 364c78.977 0 143-64.023 143-143S448.977 78 370 78s-143 64.023-143 143 64.023 143 143 143z","stroke":"#fff","stroke-width":"4","stroke-miterlimit":"10"}}),_c('path',{attrs:{"opacity":".63","d":"M370 428c114.323 0 207-92.677 207-207S484.323 14 370 14s-207 92.677-207 207 92.677 207 207 207z","stroke":"#fff","stroke-width":"4","stroke-miterlimit":"10"}}),_c('path',{attrs:{"opacity":".63","d":"M370 504c156.297 0 283-126.703 283-283S526.297-62 370-62 87 64.703 87 221s126.703 283 283 283z","stroke":"#fff","stroke-width":"4","stroke-miterlimit":"10"}}),_c('path',{attrs:{"opacity":".63","d":"M370 575c195.509 0 354-158.491 354-354S565.509-133 370-133 16 25.491 16 221s158.491 354 354 354z","stroke":"#fff","stroke-width":"4","stroke-miterlimit":"10"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h740v286H0z"}})])])])
          )
        }
      }
    